.app {
  min-height: 100vh;
  background-color: var(--color-background-primary);
}
